var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-item"},[_c('div',{staticClass:"status-wrap",class:_vm.className,style:({
      color: _vm.color,
      backgroundColor: _vm.bgColor,
      border: `1px solid ${_vm.borderColor}`,
    })}),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }